module.exports = __webpack_public_path__ + "img/icon.1ba03816.webp";